<template>
  <Page route-path="/digitalPlatform.html">
    <div class="body">
      <div class="first-image">
        <div class="banner-container">
          <img
            v-if="isNormal"
            class="backgroud-image"
            src="@/assets/home/carousel-0.png"
          />
          <img
            v-else
            class="backgroud-image"
            src="@/assets/mobile/lowcode/lowcode-banner.svg"
          />
        </div>
        <div class="head-content">
          <div class="image-title">数字化综合管理平台</div>
          <div class="text">
            整合电商、销售、生产、供应链、设备与能耗、质量等，通过一个平台实现业务全流程数字化、可视化与智能化管理，让企业看得清、管得住、赚得多
          </div>
          <div class="s-title">让增长可预见，让管理零盲区</div>

          <!-- <div class="content" style="flex: 1; padding: 0">
            <div class="explain">免费体验</div>
            <div class="explain">售前咨询</div>
          </div> -->
        </div>
      </div>

      <div class="block core-values">
        <div class="title">平台核心优势</div>
        <div class="goo">
          <div class="goo-item" v-reveal>
            <div class="goo-item-left">
              <img
                class="core-values-item_image_svg"
                src="@/assets/digitalform/core-values-1.svg"
              />
            </div>
            <div class="goo-item-right">
              <div class="goo-item-right-title">打破信息孤岛</div>
              <div class="goo-item-right-subtitle">
                让数据自己跑起来，告别到处问、到处找
              </div>
              <div class="goo-item-right-content">
                让数据自己跑起来，告别到处问、到处找。您一眼就能看到：刚接的订单到哪步了？库存还够不够？这个月哪条生产线最忙？
                信息透明，心里踏实。
              </div>
            </div>
          </div>
          <div class="goo-item" v-reveal>
            <div class="goo-item-left">
              <img
                class="core-values-item_image_svg"
                src="@/assets/digitalform/core-values-2.svg"
              />
            </div>
            <div class="goo-item-right">
              <div class="goo-item-right-title">数据实时分析</div>
              <div class="goo-item-right-subtitle">
                第一时间感知，而不是事后补救。
              </div>
              <div class="goo-item-right-content">
                数据不再是每天或每周汇总一次，而是每秒都在更新、计算和分析。您能看到当前的生产效率、正在消耗的库存等波动。
              </div>
            </div>
          </div>
          <div class="goo-item" v-reveal>
            <div class="goo-item-left">
              <img
                class="core-values-item_image_svg"
                src="@/assets/digitalform/core-values-3.svg"
              />
            </div>
            <div class="goo-item-right">
              <div class="goo-item-right-title">高效协同联动</div>
              <div class="goo-item-right-subtitle">
                流程在系统中自动跑，每个环节责任到人、时限明确
              </div>
              <div class="goo-item-right-content">
                您不需要每天追问“事情办到哪了”，系统会推动每个人在正确时间做正确的事。
              </div>
            </div>
          </div>
          <div class="goo-item" v-reveal>
            <div class="goo-item-left">
              <img
                class="core-values-item_image_svg"
                src="@/assets/digitalform/core-values-4.svg"
              />
            </div>
            <div class="goo-item-right">
              <div class="goo-item-right-title">优化资源配置</div>
              <div class="goo-item-right-subtitle">让每分资源都用在刀刃上</div>
              <div class="goo-item-right-content">
                让人员、设备、物料、资金根据实时需求动态匹配，杜绝隐形浪费，最大化投入产出比。
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="block advantage">
        <div class="title">产品能力</div>
        <div class="content" v-reveal>
          <img
            class="advantage-backgroud-image"
            src="@/assets/digitalform/nengli.png"
          />
        </div>
      </div>
      <div class="block advantage" style="background-color: #fff">
        <div class="title">链聚数字化综合管理平台7大优势</div>
        <div class="content" v-reveal>
          <img
            class="advantage-backgroud-image"
            src="@/assets/digitalform/youshi.png"
          />
        </div>
      </div>
      <div class="block advantage" style="background-color: #fff">
        <div class="title">业务流程图</div>
        <div class="content" v-reveal>
          <img
            class="advantage-backgroud-image"
            src="@/assets/digitalform/liucheng.png"
          />
        </div>
      </div>
      <div class="block advantage" style="background-color: #fff">
        <div class="title">平台架构</div>
        <div
          class="content"
          style="background: #fff; margin: 20px auto"
          v-reveal
        >
          <img
            class="advantage-backgroud-image"
            src="@/assets/digitalform/framework.png"
          />
        </div>
      </div>

      <!-- <div class="block adaptability">
        <div class="title">软件适应性强</div>
        <div class="introduction" v-reveal>
          多端数据同步，手机、电脑数据实时同步，操作体验无缝衔接
        </div>
        <div class="content" v-reveal>
          <img
            v-if="isNormal"
            class="advantage-backgroud-image"
            src="@/assets/digitalform/adaptability-main.png"
          />
        </div>
      </div> -->
      <!-- <div class="block advantage" style="background-color: #fff">
        <div class="title">专业贴心的服务流程</div>
        <div class="process" v-reveal>
          <div class="process-item">
            <div class="process-item-img">
              <img src="@/assets/digitalform/shouqian.jpg" />
            </div>
            <h4>售前</h4>
            <ul>
              <li>痛点咨询</li>
              <li>演示讲解</li>
              <li>案例分享</li>
              <li>解决方案规划</li>
            </ul>
          </div>
          <img style="width: 50px" src="@/assets/digitalform/arrow.svg" />
          <div class="process-item">
            <div class="process-item-img">
              <img src="@/assets/digitalform/shouzhong.jpg" />
            </div>
            <h4>售中</h4>
            <ul>
              <li>实地调研</li>
              <li>方案设计</li>
              <li>驻场实施</li>
              <li>培训上手</li>
            </ul>
          </div>
          <img style="width: 50px" src="@/assets/digitalform/arrow.svg" />
          <div class="process-item">
            <div class="process-item-img">
              <img src="@/assets/digitalform/shouhou.jpg" />
            </div>
            <h4>售后</h4>
            <ul>
              <li>7*24小时系统保障</li>
              <li>7*12小时在线客服</li>
              <li>定期售后回访</li>
              <li>每月在线培训</li>
            </ul>
          </div>
        </div>
      </div> -->
      <!-- <div class="block advantage" style="background: #fff">
        <div class="title">系统流程</div>
        <div
          class="content"
          style="background: #fff; margin: 20px auto"
          v-reveal
        >
          <img
            class="advantage-backgroud-image"
            src="@/assets/digitalform/flow.png"
          />
        </div>
      </div> -->
      <!-- <div class="block platform">
        <div class="title">一站式业务数字化管理平台</div>
        <div class="content" v-reveal>
          <div class="platform-menus">
            <div
              class="menu"
              :class="{ menu_active: item.key == selectMenuKey }"
              v-for="(item, index) in platfromMenus"
              :key="index"
              @click="onSelectMenuKey(item.key)"
            >
              <img class="platform-icon" :src="platformIcons[index]" />
              {{ item.menuName }}
            </div>
          </div>
          <div class="platform-image">
            <img
              class="platform-image_img"
              src="@/assets/digitalform/flow.png"
            />
          </div>
        </div>
      </div> -->
      <div class="block platform" style="max-width: 1200px; margin: auto">
        <div class="title">核心功能</div>
        <div class="tabs">
          <div
            v-for="(item, index) in tabs"
            :key="item.key"
            :class="{ active: activeIndex === index }"
            @click="activeIndex = index"
          >
            {{ item.label }}
          </div>
        </div>

        <img class="platform-image_img" :src="tabs[activeIndex].img" />
      </div>
      <div class="block contact">
        <div
          style="
            display: flex;
            justify-content: center;
            max-width: 1400px;
            margin: auto;
            padding-bottom: 66px;
            padding-top: 62px;
            align-items: end;
          "
        >
          <div style="flex: 1">
            <div
              class="title"
              style="
                font-weight: 400;
                font-size: 20px;
                color: #040420;
                margin-top: 0;
                text-align: left;
              "
            >
              联系我们
            </div>
            <div
              class="introduction"
              style="
                text-align: left;
                font-weight: 500;
                font-size: 32px;
                color: #040420;
              "
            >
              专业顾问将免费为您提供数字化解决方案！
            </div>
          </div>

          <!-- <div class="content" style="flex: 1; padding: 0">
            <div class="explain">数字化产品</div>
            <div class="explain">项目整包服务</div>
            <div class="explain">IT人力外包服务</div>
          </div> -->
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
// import { mapGetters } from "vuex";

import { ResponsiveBase } from "../../layout/reponsive-base";
import icon1 from "@/assets/digitalform/platform-1-icon.svg";
import icon2 from "@/assets/digitalform/platform-2-icon.svg";
import icon3 from "@/assets/digitalform/platform-3-icon.svg";
import icon4 from "@/assets/digitalform/platform-4-icon.svg";
import icon5 from "@/assets/digitalform/platform-5-icon.svg";
import icon6 from "@/assets/digitalform/platform-6-icon.svg";
import platformImg1 from "@/assets/digitalform/platform-1.png";
import platformImg2 from "@/assets/digitalform/platform-2.png";
import platformImg3 from "@/assets/digitalform/platform-3.png";
import platformImg4 from "@/assets/digitalform/platform-4.png";
import platformImg5 from "@/assets/digitalform/platform-5.png";
import platformImg6 from "@/assets/digitalform/platform-6.png";

export default {
  name: "DigitalPlatformPage",
  mixins: [ResponsiveBase],

  data() {
    return {
      activeIndex: 0,
      tabs: [
        {
          key: "ecommerce",
          label: "电子商务",
          img: require("@/assets/digitalform/shangwu.png"),
        },
        {
          key: "sale",
          label: "销售管理",
          img: require("@/assets/digitalform/sale.png"),
        },
        {
          key: "purchase",
          label: "采购管理",
          img: require("@/assets/digitalform/caigou.png"),
        },
        {
          key: "produce",
          label: "生产管理",
          img: require("@/assets/digitalform/shengchan.png"),
        },
        {
          key: "warehouse",
          label: "仓库管理",
          img: require("@/assets/digitalform/cangku.png"),
        },
        {
          key: "device",
          label: "设备管理",
          img: require("@/assets/digitalform/shebei.png"),
        },
        {
          key: "device",
          label: "质量管理",
          img: require("@/assets/digitalform/zhiliang.png"),
        },
        {
          key: "analysis",
          label: "数据分析",
          img: require("@/assets/digitalform/fenxi.png"),
        },
      ],
      selectMenuKey: 1,
      platfromMenus: [
        {
          key: 1,
          menuName: "业务协同",
          icon: "",
        },
        {
          key: 2,
          menuName: "数据贯通",
          icon: "",
        },
        {
          key: 3,
          menuName: "操作简单",
          icon: "",
        },
        {
          key: 4,
          menuName: "部署灵活",
          icon: "",
        },
        {
          key: 5,
          menuName: "决策智能",
          icon: "",
        },
        {
          key: 6,
          menuName: "支持个性化",
          icon: "",
        },
      ],
      platformIcons: [icon1, icon2, icon3, icon4, icon5, icon6],
      platformImgs: [
        platformImg1,
        platformImg2,
        platformImg3,
        platformImg4,
        platformImg5,
        platformImg6,
      ],
    };
  },
  created() {},
  inject: ["pageIndicator"],

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },

    routeTo(route) {
      if (route.endsWith(".html")) {
        document.location.href = route;
      } else {
        console.error("上下文不允许使用路由机制！");
      }
    },
    onSelectMenuKey(key) {
      this.selectMenuKey = key;
    },
  },
};
</script>
<style lang="less" scoped>
// 平台核心优势
.goo {
  max-width: 1200px;
  margin: 60px auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 列 */
  grid-template-rows: repeat(2, auto); /* 2 行 */
  gap: 24px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr); /* 1 行 4 列 */
    grid-template-rows: 1fr;
  }
  .goo-item {
    max-width: 662px;
    display: flex;
    align-items: start;
    gap: 24px;
    background: #ffffff;
    box-shadow: 5px 5px 15px 1px rgba(96, 129, 217, 0.15);
    border-radius: 0px 0px 0px 0px;
    border: 4px solid #ffffff;
    padding: 24px 40px;
    .goo-item-left {
    }
    .goo-item-right {
      .goo-item-right-title {
        font-weight: 500;
        font-size: 28px;
        color: #040420;
        line-height: 39px;
      }
      .goo-item-right-subtitle {
        font-weight: 500;
        font-size: 20px;
        color: #040420;
        line-height: 28px;
        margin: 21px 0 25px 0;
      }
      .goo-item-right-content {
        font-weight: 400;
        font-size: 16px;
        color: #727272;
        line-height: 30px;
      }
    }
  }
}
// 贴心服务
.process {
  display: flex;
  margin: 50px auto;
  justify-content: space-between;
  max-width: 1280px;
  @media screen and (max-width: 920px) {
    flex-direction: column;
    align-items: center;
  }
  .process-item {
    width: 266px;
    height: 376px;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 6px 0px;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgb(255, 255, 255);
    border-width: 2px;
    border-style: dashed;
    border-color: rgb(18, 107, 242);
    border-image: initial;
    border-radius: 14px;
    .process-item-img {
      border-radius: 160px;
      overflow: hidden;
      width: 140px;
      height: 140px;
      position: relative;
      img {
        width: 150px;
        position: absolute;
        top: -4px;
        left: -4px;
      }
    }
    h4 {
      width: 91px;
      height: 27px;
      color: rgb(255, 255, 255);
      text-align: center;
      font-size: 16px;
      line-height: 27px;
      letter-spacing: 1px;
      background: rgb(18, 107, 242);
      border-radius: 14px;
      margin: 8px auto 0px;
    }
    ul {
      width: 214px;
      list-style: none;
      margin: 16px auto 0px;
      padding: 0;
      li {
        margin-bottom: 8px;
        width: 214px;
        height: 30px;
        font-size: 14px;
        text-align: center;
        color: rgb(0, 0, 0);
        line-height: 30px;
        letter-spacing: 1px;
        background: rgb(233, 240, 253);
        border-radius: 14px;
      }
    }
  }
}
// 核心功能
.tabs {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  max-width: 1200px;
  margin-top: 60px;

  div {
    font-weight: 500;
    font-size: 20px;
    padding: 0 15px;
    text-align: center;
  }
  .active {
    color: #2e64f3;
    border-bottom: #2e64f3 solid 2px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, auto); /* 2 行 */
    row-gap: 20px;
    div {
      font-size: 14px;
      padding: 0 10px;
    }
  }
}
.s-title {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 32px;
  color: #040420;
  line-height: 45px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.body {
  padding-top: 65px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.banner-container {
  position: absolute;
  top: 64px;
  width: 100%;
  height: 428px;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.backgroud-image {
  height: 100%;
  width: 100%;
  min-width: 1280px;
  object-fit: cover;
}

@media screen and(max-width: 850px) {
  .head-content > .text {
    max-width: 320px;
  }

  .backgroud-image {
    min-width: auto;
  }
}

.first-image {
  height: 428px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  width: 100%;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .head-content {
    width: 100%;
    max-width: 1280px;
    z-index: 1000;
    margin: 0px 20px;
  }

  .image-title {
    height: 58px;
    font-size: 58px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 58px;

    @media screen and (max-width: 850px) {
      font-size: 30px;
    }
  }

  .text {
    width: 600px;
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    line-height: 30px;
    margin-top: 40px;
    margin-bottom: 20px;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;

      width: 100%;
    }
  }

  .el-button {
    width: 140px;
    height: 48px;
    font-size: 20px;
    border: 1px solid #ffffff;
    color: #ffffff;
    background-color: #ffffff00;
    font-weight: 500;
  }

  .el-button:hover {
    color: #2e64f3;
    background-color: #ffffff;
  }
}

.title {
  font-size: 36px;
  font-weight: 500;
  color: #040420;
  margin-top: 100px;
  text-align: center;
  -webkit-text-stroke: thin;

  @media screen and (max-width: 850px) {
    font-size: 24px;
  }
}

.block {
  width: 100%;

  .introduction {
    margin-top: 30px;
    font-size: 20px;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    text-align: center;

    @media screen and (max-width: 850px) {
      font-size: 14px;
      line-height: 24px;
    }
  }

  .content {
    display: flex;
    max-width: 1280px;
    width: 100%;
    padding: 60px 20px;
    margin: 0 auto;
    padding: 60px 20px;
  }
}

.platform {
  .content {
    gap: 16px;
  }

  .platform-menus {
    width: 268px;

    .menu {
      height: 64px;
      padding: 23px 34px;
      border-radius: 16px 16px 16px 16px;
      gap: 16px;
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;

      .platform-icon {
        width: 24px;
        height: 24px;
      }
    }

    .menu_active {
      background: #f5f8ff;
      color: #2e64f3;
    }
  }

  .platform-image_img {
    width: 100%;
    margin: 20px 0;
  }
}

.advantage {
  background-color: #f0f2f9;
}
.core-values-item_image_svg {
  width: 70px;
  height: 70px;
}
.core-values {
  .content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .core-values-item {
      width: 260px;
      display: flex;
      align-items: top;

      .core-values-item_title {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 24px;
        color: #040420;
        line-height: 34px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: 47px;
        margin-bottom: 24px;
      }

      .core-values-item_text {
        font-size: 16px;
        font-family: Source Han Sans CN-Medium;
        font-weight: 400;
        color: #727272;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}

.adaptability {
  background-image: url("../../assets/digitalform/adaptability-back.png");
  background-repeat: no-repeat;
  background-position: inherit;
  background-size: cover;

  .content {
    padding: 60px 0px 0px 0px;
  }
}

.contact {
  background-image: url("../../assets/digitalform/bbg.png");

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 20px;

    .explain {
      background: #2e64f3;
      border-radius: 4px 4px 4px 4px;
      padding: 12px 40px;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
.content {
  display: flex;
  justify-content: start;
  align-items: center;
  column-gap: 20px;

  .explain {
    background: #2e64f3;
    border-radius: 4px 4px 4px 4px;
    padding: 12px 40px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
  }
}
</style>
